// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationRight_container__2vnT6","minimizer":"NavigationRight_minimizer__2XwmO"};